const g = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4xOTMgN0gxMHYySDNWMmgydjMuMjdDNi43MjUgMy4xODMgOS4xOTYgMiAxMiAyYzUuNTIzIDAgMTAgNC40NzcgMTAgMTBzLTQuNDc3IDEwLTEwIDEwUzIgMTcuNTIzIDIgMTJoMmE4IDggMCAxIDAgOC04QzkuNjA2IDQgNy41NTQgNS4wNzkgNi4xOTMgN3oiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  g as default
};
//# sourceMappingURL=restore-c21fcb38.mjs.map
